import React, {Component} from 'react';
const $ = require("jquery");
import  './style/fonts/index.scss';
import  './style/app.scss';
import Cookies from 'js-cookie';
import LeftMenu from "./components/LeftMenu";
import Loading from "./components/Loading";
import Connection from "./components/Connection";
import TopBar from "./components/TopBar";
import AgentList from "./components/agents/AgentList";
import ChatList from "./components/chat/ChatList";
import Traffic from "./components/traffic/Traffic";
import Archives from "./components/archives/Archives";
import Settings from "./components/settings/Settings";
import Reports from "./components/reports/Reports";
import Authentication from "./components/authentication/Authentication";
import {connect} from "react-redux";
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'react-intl-tel-input/dist/main.css';
import 'sweetalert2/src/sweetalert2.scss';
import ConnectionNode from "extension/nodejs";
import PlaySound from "./components/PlaySound";
import "simplebar/src/simplebar.css";
import Installation from "./components/welcome/Installation";
import {seo} from "lib/helper";
import {
    NumberParam,
    QueryParamProvider,
    useQueryParam,
} from 'use-query-params';

import {
    BrowserRouter,
    Routes,
    Route,
    useNavigate,
    useLocation
} from "react-router-dom";
import axios from "axios";



@connect((store) => {
    return {
        chatprop: store.chatprop
    };
})

class App extends Component {

    constructor(props) {

        super(props);
        this.state = {
            isLoading: false
        }

    }



    async componentDidMount() {

		
		this.props.dispatch({
            type: 'SET_ACTIVE_CHAT_LOADED',
            data: false
        });


        this.props.dispatch({
            type: 'SET_URL',
            data: process.env.REACT_APP_SERVICE
        });

        const defaultHeaders = {
            'content-type': 'application/x-www-form-urlencoded',
        }
        var formData = new FormData();
        formData.append("hv_token", (typeof Cookies.get('hv_token')==="undefined") ? "" : Cookies.get('hv_token'));
        await axios.post(process.env.REACT_APP_SERVICE + "initialState", formData, {
            headers: defaultHeaders,
        }).then((response) => {
            if (response.status === 200) {
                if (typeof response.data !== "undefined") {

                    if(typeof response.data.authentication!=="undefined"){

                            if (typeof response.data.license_number !== "undefined") {
                                this.props.dispatch({
                                    type: 'SET_LICENSE_NUMBER',
                                    data: response.data.license_number
                                });
                            }
                            if(response.data.authentication===true){
                                this.props.dispatch({
                                    type: 'AUTHENTICATION',
                                    data: true
                                });
                                if (typeof response.data.create_step !== "undefined") {
                                    this.props.dispatch({
                                        type: 'SET_STEP',
                                        data: response.data.create_step
                                    });
                                }
                                if (typeof response.data.departments !== "undefined") {
                                    this.props.dispatch({
                                        type: 'SET_ALL_DEPARTMENTS',
                                        data: response.data.departments
                                    });
                                }

                                if (typeof response.data.menu !== "undefined") {
                                    this.props.dispatch({
                                        type: 'SET_LEFT_MENU',
                                        data: response.data.menu
                                    });
                                }
                                if (typeof response.data.token !== "undefined") {
                                    this.props.dispatch({
                                        type: 'SET_BEARER',
                                        data: response.data.token
                                    });
                                }

                                if (typeof response.data.customers !== "undefined") {

                                    this.props.dispatch({
                                        type: 'SET_CUSTOMERS',
                                        data: response.data.customers
                                    });
                                }
								
								if (typeof response.data.bannedUsers !== "undefined") {
                                    this.props.dispatch({
                                        type: 'SET_BANNED_USERS',
                                        data: response.data.bannedUsers
                                    });
                                }
								
                                if (typeof response.data.active_chats !== "undefined") {

                                    this.props.dispatch({
                                        type: 'SET_ACTIVE_CHAT',
                                        data: response.data.active_chats
                                    });
                                }
                                if (typeof response.data.cannedResponse !== "undefined") {

                                    this.props.dispatch({
                                        type: 'SET_CANNED_RESPONSE',
                                        data: response.data.cannedResponse
                                    });
                                }
                                if(typeof response.data.settings!=="undefined"){
                                    this.props.dispatch({
                                        type: 'SET_SETTINGS',
                                        data: response.data.settings
                                    });
                                }

                                if (typeof response.data.operator !== "undefined") {
									
									if (typeof response.data.operator.dark_mode !== "undefined" && response.data.operator.dark_mode == 1) {
										document.body.classList.add('dark_mode');
									}
									
                                    this.props.dispatch({
                                        type: 'SET_OPERATOR',
                                        data: response.data.operator
                                    });
                                }

                                if (typeof response.data.allAgents !== "undefined") {
                                    this.props.dispatch({
                                        type: 'SET_ALL_AGENTS',
                                        data: response.data.allAgents
                                    });
                                }
                                this.props.dispatch({
                                    type: 'SET_PROCESS',
                                    data: true
                                });

                                if (typeof this.props.chatprop.bearer_token !== "undefined") {
                                    global.NODECONNECT = new ConnectionNode(this.props.dispatch, this.props.chatprop);
                                }

                                this.setState({
                                    isLoading: true
                                });

                            } else{
                                this.props.dispatch({
                                    type: 'AUTHENTICATION',
                                    data: false
                                });
                                this.setState({
                                    isLoading: true
                                });

                            }

                        this.props.dispatch({
                            type: 'SET_DOCUMENT_DEFAULT_TITLE',
                            data: "HelperVia | LiveChat"
                        });
                        this.props.dispatch({
                            type: 'SET_DOCUMENT_TITLE',
                            data: "HelperVia | LiveChat"
                        });


                    }


                }
            }
        });

		
		
		

		axios.post(process.env.REACT_APP_SERVICE + "activeChats", formData, {
            headers: defaultHeaders,
        }).then((response) => {
            if (response.status === 200) {

                if (typeof response.data !== "undefined") {
								
								
					this.props.dispatch({
						type: 'SET_ACTIVE_CHAT_LOADED',
						data: true
					});
								
                                if (typeof response.data.active_chats !== "undefined") {
                                    this.props.dispatch({
                                        type: 'SET_ACTIVE_CHAT',
                                        data: response.data.active_chats
                                    });
                                }

                }
            }
        });
		
    }


    render() {


        if (this.state.isLoading == false
            || typeof this.props.chatprop.authentication==="undefined"
            || typeof this.props.chatprop.url==="undefined"

        ) {
            return (<React.Fragment><Loading/></React.Fragment>);
        }

            if(this.props.chatprop.create_step==0){
                return (<Installation/>);
            } else {
                if(this.props.chatprop.authentication===true) {
                    if (this.props.chatprop.connection === true) {
                        return (

                            <BrowserRouter>

                                <QueryParamProvider ReactRouterRoute={RouteAdapter}>

                                    <React.Fragment>
                                        <PlaySound/>
                                        <ToastContainer
                                            position="top-center"
                                            autoClose={5000}
                                            hideProgressBar={false}
                                            newestOnTop
                                            closeOnClick
                                            rtl={false}
                                            pauseOnFocusLoss
                                            draggable
                                            pauseOnHover
                                        />
                                        <div className="main-wrapper">
                                            <div className="content main_content">
                                                <LeftMenu/>
                                                <div className="page-center">
                                                    <TopBar />
                                                    <div className={"page-center-wrap "+ (this.props.chatprop.operator['away']==1 ? "page-center-wrap-height" : "")}>
                                                        <Routes>
                                                            <Route path={"/agents"}
                                                                   element={<AgentList/>}/>
                                                            <Route path={"/traffic"}
                                                                   element={<Traffic/>}/>
                                                            <Route path={"/"}
                                                                   element={<ChatList/>}/>
															<Route path={"/chat"}
                                                                   element={<ChatList/>}/>
                                                            <Route path={"/chat/:id"}
                                                                   element={<ChatList/>}/>
                                                            <Route path={"/archive"}
                                                                   element={<Archives/>}/>
                                                            <Route path={"/archive/:id"}
                                                                   element={<Archives/>}/>
                                                            <Route path={"/settings"}
                                                                   element={<Settings/>}/>
                                                            <Route path={"/settings/:link"}
                                                                   element={<Settings/>}/>
															<Route path={"/reports"}
                                                                   element={<Reports/>}/>
                                                            <Route path={"/reports/:link"}
                                                                   element={<Reports/>}/>

                                                        </Routes>
                                                    </div>

                                                </div>


                                            </div>
                                        </div>


                                    </React.Fragment>

                                </QueryParamProvider>

                            </BrowserRouter>


                        );
                    } else {
                        return (<React.Fragment><Connection/></React.Fragment>);
                    }
                } else {
                    return( <Authentication/> );
                }
            }



    }
}
const RouteAdapter = ({ children }) => {
    const navigate = useNavigate();
    const location = useLocation();

    const adaptedHistory = React.useMemo(
        () => ({
            replace(location) {
                navigate(location, { replace: true, state: location.state });
            },
            push(location) {
                navigate(location, { replace: false, state: location.state });
            },
        }),
        [navigate]
    );
    return children({ history: adaptedHistory, location });
};
export default App;
